/**
 * Created by stonewang on 2017/8/18.
 */
import React from 'react';
import { hashHistory } from 'react-router';
import { Form, Input, Select, Button, Row, Col, message, InputNumber, Table } from 'antd';
import { DmsTab } from 'Components';
import ProductModal from './productModal';
import { sKeylist } from '../../service/dictionary/dataitem';
import { add } from '../../service/inventory/entry';
import { listForBill as houseList } from '../../service/inventory/house';
import { getLocalList } from '../../service/inventory/house'
import {showSpin,hideSpin} from 'Utils';
const FormItem = Form.Item;
const { TextArea } = Input;

class AddEntry extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      id: parseInt(this.props.params.id, 10),
      entry_type: [],
      storageList: [],
      localList: [],
      products: [],
      relationId: '',
      storageType: '',
      localParam: {
        storageId: 0,
        p: 1,
        s: 1000
      }
    }
    this.editDone = this.editDone.bind(this);
    this.openModal = this.openModal.bind(this);
    this.deleteLine = this.deleteLine.bind(this);
    this.selectProduct = this.selectProduct.bind(this);
    this.getLocals = this.getLocals.bind(this);
  }

  componentWillMount () { //准备数据
    const self = this;
    sKeylist({ sKey: 'entry_type' }).then(res => { //门店运营方式
      let timer = window.setInterval(function () {
        if (self.mounted) {
          window.clearInterval(timer);
          self.setState({ entry_type: res.data.filter(x => x.sKey == 1 || x.sKey == 8) })
        }
      }, 200);
    })
    houseList({ storageType: 1, p: 1, s: 1000 }).then(res => { //门店运营方式
      let timer = window.setInterval(function () {
        if (self.mounted) {
          window.clearInterval(timer);
          self.setState({ storageList: res.data })
        }
      }, 200);
    })
  }

  componentDidMount () {
    this.mounted = true;
  }

  cancelHandle () {
    hashHistory.goBack()
  }

  getLocals (e) {
    const self = this;
    let val = parseInt(e, 10);
    let tmp = this.state.storageList.filter(x => x.id === val)[0];

    this.setState({
      ...this.state,
      relationId: tmp.relationId,
      storageType: tmp.storageType,
      localParam: { ...self.state.localParam, storageId: val }
    }, () => {
      getLocalList(self.state.localParam).then(res => {
        if (res.status) {
          self.setState({
            localList: res.data.map(x => {
              return {
                id: x.id,
                name: x.code,
              }
            })
          });
        }
      })
    })
  }

  submitHandle () {
    const self = this;
    const { relationId, storageType } = this.state;
    const { validateFields, getFieldsValue } = this.props.form;

    validateFields((errors) => {//表单校验
      if (errors) {
        return
      }//表单校验有误，则不执行下面的代码
      const data = {
        ...getFieldsValue() //获取用户输入
      };
      let storageBillProduct = [...self.state.products];
      const tmp = storageBillProduct.map(x => {
        return {
          ...x,
          productSpecId: (x.productSpecId + '').match('specId') ? null : x.productSpecId
        }
      });
      storageBillProduct = [...tmp];
      // console.log(`你正在提交数据：${JSON.stringify({ ...data, storageBillProduct })}`);

      showSpin();
      add({ ...data, relationId, storageType, storageBillProduct }).then(res => {
        hideSpin();
        message[res.status ? 'success' : 'error'](res.message);
        res.status && hashHistory.goBack()
      });
    })
  }

  editDone (data) {

    this.setState({ ...this.state, products: data })
  }

  deleteLine (index) {
    const { products } = this.state;
    products.splice(index, 1);
    this.setState({ ...this.state, products })
  }

  openModal () {
    this.productModal.showModal();
  }

  selectProduct (list) {//从弹框中接收数据
    let products = [...this.state.products];
    let arr = [];
    list.forEach(item => {
      if (products.findIndex(x => x.productSpecId === item.specId) === -1) {
        arr.push({
          productId: item.id,//产品的ID
          productSpecId: item.specId,//产品的规格ID
          name: item.name,
          specName: item.specUnionKey,
          unit: item.unit,
          unitText: item.unitText,
          storageNum: 1
        })
      }
    })

    this.setState({ products: [...products, ...arr] })
  }

  productInfoChange (index, name, val) {
    let list = [...this.state.products];
    let obj = {
      ...list[index],
      [name]: val
    };
    list.splice(index, 1, obj);
    this.setState({ products: list });
  }


  render () {
    const self = this;
    const { products, id, entry_type, storageList, localList } = this.state;
    const { getFieldDecorator } = this.props.form;
    const productProps = {
      rowKey: 'productSpecId',
      columns: [
        {
          title: '序号',
          dataIndex: 'sort_no',
          width: '60px',
          className: 'alignCenter',
          render: (text, record, index) => index + 1
        }, {
          title: '产品名称',
          dataIndex: 'name',
          width: '30%',
        }, {
          title: '规格',
          dataIndex: 'specName',
          width: '30%',
        }, {
          title: '单位',
          dataIndex: 'unitText',
          width: '100px',
          className: 'alignCenter',
        }, {
          title: '入库数量',
          dataIndex: 'storageNum',
          className: 'alignCenter',
          render: (text, record, index) => <FormItem label={null} hasFeedback style={{ marginBottom: '0px' }}>
            {getFieldDecorator(`storageNum_${record.productSpecId}`, {
              initialValue: record.storageNum || 1,
              rules: [
                {
                  required: true,
                  message: '入库数量不能为空'
                },
              ],
              getValueFromEvent: (e) => {
                this.productInfoChange(index, 'storageNum', e);
                return e;
              }
            })(<InputNumber min={1}
                            style={{ width: '100%' }}/>)}
          </FormItem>
        },
        {
          title: '操作',
          dataIndex: '',
          className: 'alignCenter',
          render: (text, record, index) => <a onClick={this.deleteLine.bind(this, index)} style={{ color: '#d61418' }}>删除</a>
        },
      ],
      dataSource: products
    };
    return <div className="dms-body">
      <DmsTab options={[`${id > 0 ? '编辑' : '新建'}入库单`]} defaultKey={0}>
        <Button onClick={this.cancelHandle.bind(this)}>取消</Button>
        <Button type='primary' onClick={this.submitHandle.bind(this)}>保存</Button>
      </DmsTab>
      <div className="dms-table-box">
        <Form layout="horizontal">
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <div id="storageIdBox">
                <FormItem label="入库仓库：" hasFeedback>
                  {getFieldDecorator('storageId', {
                    rules: [
                      {
                        required: true,
                        message: '请选择入库仓库'
                      },
                    ],
                    getValueFromEvent: (e) => {
                      if (e) {
                        self.getLocals(e);
                      }
                      self.props.form.setFields({
                        localId: {
                          value: undefined,
                          errors: null,
                        },
                      });
                      return e;
                    }
                  })(<Select
                    allowClear
                    showSearch
                    style={{ width: '100%' }}
                    placeholder="请选择入库仓库"
                    optionFilterProp="desc"
                    getPopupContainer={() => document.getElementById('storageIdBox')}
                  >
                    {
                      storageList.map((item, index) => {
                        return <Select.Option key={index + ''} value={item.id + ''}
                                              desc={item.name}>{item.name}</Select.Option>
                      })
                    }
                  </Select>)}
                </FormItem>
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <div id="localIdBox">
                <FormItem label="入库货位：" hasFeedback>
                  {getFieldDecorator('localId', {
                    rules: [
                      {
                        required: localList.length > 0 ? true : false,
                        message: '请选择入库货位'
                      },
                    ],
                  })(<Select
                    allowClear
                    showSearch
                    style={{ width: '100%' }}
                    placeholder="请选择入库货位"
                    optionFilterProp="desc"
                    getPopupContainer={() => document.getElementById('localIdBox')}
                  >
                    {
                      localList.map((item, index) => {
                        return <Select.Option key={index + ''} value={item.id + ''}
                                              desc={item.name}>{item.name}</Select.Option>
                      })
                    }
                  </Select>)}
                </FormItem>
              </div>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <div id="typeBox">
                <FormItem label="入库类型：" hasFeedback>
                  {getFieldDecorator('type', {
                    initialValue: '1',
                    rules: [
                      {
                        required: false,
                        message: '请输入渠道编码'
                      },
                    ],
                  })(<Select
                    allowClear
                    style={{ width: '100%' }}
                    placeholder="请选择入库类型"
                    getPopupContainer={() => document.getElementById('typeBox')}
                  >
                    {
                      entry_type.map((item, index) => {
                        return <Select.Option key={index + ''} value={item.sKey}>{item.name}</Select.Option>
                      })
                    }
                  </Select>)}
                </FormItem>
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem label="入库单号：" hasFeedback>
                {/*{getFieldDecorator('billNo', {
                 rules: [
                 {
                 required: false,
                 },
                 ],
                 })(<Input/>)}*/}
                <Input disabled={true} placeholder="入库单号自动生成"/>
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={24}>
              <FormItem label="备注：" hasFeedback>
                {getFieldDecorator('remark', {
                  rules: [
                    {
                      required: false,
                      message: '请输入备注'
                    },
                  ],
                })(<TextArea placeholder="请输入备注" rows={4}/>)}
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
      <div className="dms-split-bar"></div>
      <DmsTab className="white-bg no-border" options={['产品']} defaultKey={0}>
        <Button icon="plus" onClick={this.openModal}>添加行</Button>
      </DmsTab>
      <div className="dms-table-box">
        <Table {...productProps} bordered pagination={false}/>
      </div>
      <ProductModal ref={(node) => {
        this.productModal = node;
      }} onOk={this.selectProduct}/>
    </div>
  }
}
export default Form.create()(AddEntry)


// WEBPACK FOOTER //
// ./src/routes/inventory/addEntry.js